/**
 * Versión del frontend para Métricas de Actividad: el hash del bundle principal que el navegador cargó
 * (`main.3783be58.js` → `3783be58`). Cambia en cada build, así que sirve para marcar deploys y ver quién sigue en
 * un bundle viejo, sin variable de entorno ni paso de CI. En desarrollo (`bundle.js`) no hay hash: `undefined`.
 */
const MAIN_BUNDLE = /\/static\/js\/main\.([A-Za-z0-9]{6,32})\.js(?:$|\?)/;

let cached: string | undefined | null = null;

/** Extrae la versión de una lista de URLs de scripts (separado para poder probarlo sin DOM). */
export function versionFromScriptSrcs(srcs: string[]): string | undefined {
  for (const src of srcs) {
    const match = MAIN_BUNDLE.exec(src);
    if (match) return match[1];
  }
  return undefined;
}

/** Versión del bundle en ejecución; se calcula una vez. Nunca tira. */
export function getAppVersion(): string | undefined {
  if (cached !== null) return cached;
  try {
    cached =
      typeof document === "undefined"
        ? undefined
        : versionFromScriptSrcs(Array.from(document.scripts).map((s) => s.src));
  } catch {
    cached = undefined;
  }
  return cached;
}
